import { useTranslate } from '@festina-life/ui/hooks'

export const AddDynamicFunctionNameCell = () => {
  const translate = useTranslate()

  return (
    <div className="flex size-full flex-col justify-center gap-x-2 pl-4">
      <div>{translate('templateViewer.addDynamicFunction.name')}</div>
      <div className="text-sm">
        {translate('templateViewer.addDynamicFunction.description')}
      </div>
    </div>
  )
}
